/**
 * Propósitos de acceso, desde el menú de usuario (INTRO-6).
 *
 * El menú de usuario se desmonta al cerrarse, así que el diálogo vive en
 * AppShell (`PurposesDialogHost`) y el menú solo lo abre con
 * `openPurposesDialog()`. Al activar, terminar o vencer un propósito se
 * vuelven a pedir los permisos efectivos: las pantallas que los leen ven el
 * cambio sin recargar la página.
 */
import React from 'react';
import { create } from 'zustand';
import { useTranslation } from 'react-i18next';
import { Modal } from '../../design-system/components/Modal';
import { usePermissionStore } from '../../store/permissionStore';

const MyPurposesPanel = React.lazy(() => import('./MyPurposesPanel'));

const usePurposesDialog = create<{ open: boolean; set: (open: boolean) => void }>((set) => ({
  open: false,
  set: (open) => set({ open }),
}));

export const openPurposesDialog = () => usePurposesDialog.getState().set(true);

export const PurposesDialogHost: React.FC = () => {
  const { t } = useTranslation(['admin', 'common']);
  const open = usePurposesDialog((s) => s.open);
  const close = () => usePurposesDialog.getState().set(false);
  if (!open) return null;
  return (
    <Modal open onClose={close} size="lg" title={t('purposes.mineTitle', 'Propósitos de acceso')}>
      <React.Suspense fallback={<div style={{ fontSize: 13, color: 'var(--color-text-muted)' }}>{t('common:loading', 'Cargando...')}</div>}>
        <MyPurposesPanel onChanged={() => { void usePermissionStore.getState().fetchEffective(); }} />
      </React.Suspense>
    </Modal>
  );
};

export default PurposesDialogHost;
